// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {
  /* background-color: rgb(44, 44, 44) !important; */
  color: antiquewhite !important;
}

.ant-table-thead > tr > th {
  color: #dddddd;
  font-weight: 700;
  background-color: transparent;
  font-size: 13px;
}

.c-dashboardInfo {
  margin-bottom: 15px;
}
.c-dashboardInfo .wrap {
  background: #ffffff;
  box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  text-align: center;
  position: relative;
  overflow: hidden;
  padding: 40px 25px 20px;
  height: 100%;
}
.c-dashboardInfo__title,
.c-dashboardInfo__subInfo {
  color: #6c6c6c;
  font-size: 1.18em;
}
.c-dashboardInfo span {
  display: block;
}
.c-dashboardInfo__count {
  font-weight: 600;
  font-size: 2.5em;
  line-height: 64px;
  color: #323c43;
}
.c-dashboardInfo .wrap:after {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  content: "";
}

.c-dashboardInfo:nth-child(1) .wrap:after {
  background: linear-gradient(82.59deg, #00c48c 0%, #00a173 100%);
}
.c-dashboardInfo:nth-child(2) .wrap:after {
  background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%);
}
.c-dashboardInfo:nth-child(3) .wrap:after {
  background: linear-gradient(69.83deg, #0084f4 0%, #00c48c 100%);
}
.c-dashboardInfo:nth-child(4) .wrap:after {
  background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%);
}
.c-dashboardInfo__title svg {
  color: #d7d7d7;
  margin-left: 5px;
}
.MuiSvgIcon-root-19 {
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: 24px;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
}

.form-control {
  display: inline;
  width: 66%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Card/card.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,uDAAuD;EACvD,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ","sourcesContent":[".ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {\n  /* background-color: rgb(44, 44, 44) !important; */\n  color: antiquewhite !important;\n}\n\n.ant-table-thead > tr > th {\n  color: #dddddd;\n  font-weight: 700;\n  background-color: transparent;\n  font-size: 13px;\n}\n\n.c-dashboardInfo {\n  margin-bottom: 15px;\n}\n.c-dashboardInfo .wrap {\n  background: #ffffff;\n  box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1);\n  border-radius: 7px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  padding: 40px 25px 20px;\n  height: 100%;\n}\n.c-dashboardInfo__title,\n.c-dashboardInfo__subInfo {\n  color: #6c6c6c;\n  font-size: 1.18em;\n}\n.c-dashboardInfo span {\n  display: block;\n}\n.c-dashboardInfo__count {\n  font-weight: 600;\n  font-size: 2.5em;\n  line-height: 64px;\n  color: #323c43;\n}\n.c-dashboardInfo .wrap:after {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 10px;\n  content: \"\";\n}\n\n.c-dashboardInfo:nth-child(1) .wrap:after {\n  background: linear-gradient(82.59deg, #00c48c 0%, #00a173 100%);\n}\n.c-dashboardInfo:nth-child(2) .wrap:after {\n  background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%);\n}\n.c-dashboardInfo:nth-child(3) .wrap:after {\n  background: linear-gradient(69.83deg, #0084f4 0%, #00c48c 100%);\n}\n.c-dashboardInfo:nth-child(4) .wrap:after {\n  background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%);\n}\n.c-dashboardInfo__title svg {\n  color: #d7d7d7;\n  margin-left: 5px;\n}\n.MuiSvgIcon-root-19 {\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 24px;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.form-control {\n  display: inline;\n  width: 66%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
